import React from 'react';

import ActiveClientsContextProvider from './ActiveClientsContextProvider';

const withActiveClientsContextProvider = (Component) => (props) => (
  <ActiveClientsContextProvider>
    <Component {...props} />
  </ActiveClientsContextProvider>
);

export {
  withActiveClientsContextProvider,
};
